export default class EntregaDestino {
	constructor(
		cep='',
        bairro='',
        cidade='',
        estado='',
        logradouro='',
        complemento='',
        ordem=null,
        entrega_id=null,
        pedido_id=null,
	){
		this.cep = cep;
        this.bairro = bairro;
        this.cidade = cidade;
        this.estado = estado;
        this.logradouro = logradouro;
        this.complemento = complemento;
        this.entrega_id = entrega_id;
        this.pedido_id = pedido_id;
        this.ordem = ordem;
	}
}
